import React, { useState } from 'react';
import { OwnerButton } from './OwnerShell';
import { TextField } from './OwnerFields';
import { UploadTile } from './UploadTile';
import { useApplicationReview } from '../../contexts/ApplicationReviewContext';
import type { OwnerApplication } from '../../types/owner';
interface Props {
  app: OwnerApplication;
  onDone: () => void;
  onCancel: () => void;
}
export function CorrectionEditor({
  app,
  onDone,
  onCancel
}: Props) {
  const {
    resubmit
  } = useApplicationReview();
  const [reg, setReg] = useState(app.vehicleReg);
  const [chassis, setChassis] = useState(app.chassis);
  const [engine, setEngine] = useState(app.engine);
  const [uploaded, setUploaded] = useState(false);
  const [error, setError] = useState('');
  const submit = () => {
    if (!uploaded) return setError('সংশোধনের প্রমাণ হিসেবে ডকুমেন্ট আপলোড করুন');
    resubmit(app.id, {
      vehicleReg: reg.trim(),
      chassis: chassis.trim().toUpperCase(),
      engine: engine.trim().toUpperCase()
    });
    onDone();
  };
  return <div className="mt-3 space-y-3 rounded-lg border border-navy-200 bg-white p-3 text-navy-900" data-id="element-1251" data-mp="2goh797zv0viy">
      <p className="text-[12.5px] font-semibold" data-id="element-1252" data-mp="2bx7jkcxvg29p">তথ্য সংশোধন করুন</p>
      <TextField id="ce-reg" label="রেজিস্ট্রেশন নম্বর" value={reg} onChange={setReg} data-id="element-1253" data-mp="26ye4ig2xs37f" />
      <TextField id="ce-chassis" label="চেসিস নম্বর" mono value={chassis} onChange={setChassis} data-id="element-1254" data-mp="26w1k7w9phgr7" />
      <TextField id="ce-engine" label="ইঞ্জিন নম্বর" mono value={engine} onChange={setEngine} data-id="element-1255" data-mp="21xglk1a3r54v" />
      <UploadTile label="রেজিস্ট্রেশন সার্টিফিকেটের স্পষ্ট ছবি" required state={uploaded ? 'uploaded' : 'missing'} fileName="reg_certificate_clear.jpg" onUpload={() => {
      setUploaded(true);
      setError('');
    }} data-id="element-1256" data-mp="2zkpe2g8itegd" />
      {error && <p className="text-[12px] font-medium text-red-600" data-id="element-1257" data-mp="2lnk9ylsdapnr">{error}</p>}
      <p className="text-[11px] text-slate-500" data-id="element-1258" data-mp="2lpd81cox01k5">পূর্বের জমা ও কর্মকর্তার মন্তব্য সংরক্ষিত থাকবে। পুনরায় জমার পর আবেদনটি ডিএমপি যাচাই সারিতে ফিরে যাবে।</p>
      <div className="grid grid-cols-2 gap-2" data-id="element-1259" data-mp="1a7vjvljthaiq">
        <OwnerButton variant="outline" className="!h-10 !text-sm" onClick={onCancel} data-id="element-1260" data-mp="1aa7zhs23r8sm">বাতিল</OwnerButton>
        <OwnerButton className="!h-10 !text-sm" onClick={submit} data-id="element-1261" data-mp="1bng6bggthy66">পুনরায় জমা দিন</OwnerButton>
      </div>
    </div>;
}